<template>
  <TextArea :disabled="isReadOnlyDialog" :rules="[() => isInvalidAgainstCommonRules()]" />
</template>

<script>
import TextArea from '@wizer/core/components/text-area/TextArea'
import SustainabilityInputMixin from '@/mixins/SustainabilityInputMixin'

export default {
  name: 'TextInput',
  mixins: [SustainabilityInputMixin],
  components: {
    TextArea,
  },
  props: {
    isReadOnlyDialog: Boolean,
    item: Object,
    isEmptyInput: Boolean,
    previouslySaved: Boolean,
  },
}
</script>
